import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ExpensePaymentCardTypes = {
  OTHER: 0,
  VISA: 1,
  MASTERCARD: 2,
  AMERICAN_EXPRESS: 3,
  DISCOVER: 4,
  JCB: 5,
  DINERS_CLUB: 6,
} as const

export type ExpensePaymentCardTypeEnum = Enum<typeof ExpensePaymentCardTypes>
